import moment from 'moment';
import { KeyMetricsCardListItemType } from '../types';

const DEFAULT_STATUS_LIST: KeyMetricsCardListItemType = {
  title: 'Number of In-Development Projects',
  num: 0,
  type: 'text',
  visibleTime: false,
  list: [
    { name: 'At risk', value: '', icon: 'error', contextTip: '', modalList: [] },
    { name: 'Monitor', value: '', modalList: [] },
    { name: 'On track', value: '', modalList: [] },
    { name: 'Others', value: '', modalList: [] },
  ],
  modalList: [],
};
const DEFAULT_GR_LIST: KeyMetricsCardListItemType = {
  domain: 'milestone',
  title: 'Official Gate Review in ',
  num: 0,
  type: 'img',
  time: moment().format('YYYY-MM') || '', // 前端取默认
  visibleTime: true,
  // visibleItemTime: false,
  list: [],
  modalList: [],
};
const DEFAULT_LAUNCH_LIST: KeyMetricsCardListItemType = {
  domain: 'gameDetail',
  title: 'Launch in ',
  num: 0,
  type: 'img',
  time: moment().format('YYYY') || '', // 前端取默认
  visibleTime: true,
  // visibleItemTime: true,
  list: [],
  modalList: [],
};

const DEFAULT_KEY_METRICS_LIST = [DEFAULT_STATUS_LIST, DEFAULT_GR_LIST, DEFAULT_LAUNCH_LIST];

export { DEFAULT_KEY_METRICS_LIST, DEFAULT_STATUS_LIST, DEFAULT_GR_LIST, DEFAULT_LAUNCH_LIST };
